import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-commercial-products',
    templateUrl: './icon-commercial-products.component.html'
})
export class IconCommercialProductsComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
